import moment from "moment";

/**
 * "Naručeno" grupne firme (telefon i računar): porudžbenica po radniku (i danu) za izabranu smenu, obroci po
 * grupama jela. Zahteva nasleđen stari tab tabs/CompanyReportTabOrders (users, selectedShift, shifts, isRange,
 * dayCategoryList, dayCategoryLabels). Pretraga iz zajedničke trake (store) sužava i spisak koji štampa/Excel čitaju
 * (`filterByShift`), pa izvoz prati ono što se vidi.
 */
export default {
  computed: {
    searchText() {
      return String(this.$store.state.report.filters.search || "")
        .toLowerCase()
        .trim();
    },
    /** Radnici izabrane smene koji odgovaraju pretrazi (ime, ID, jelo). */
    filterByShift() {
      const list = this.users.filter((user) => user.shift === this.selectedShift);
      if (!this.searchText) {
        return list;
      }
      const search = this.toLatin(this.searchText).toLowerCase();
      return list.filter((user) =>
        [user.name, user.lastname, user.id, ...user.orders.map((order) => order.name)]
          .map((part) => this.toLatin(String(part || "")).toLowerCase())
          .join(" ")
          .includes(search)
      );
    },
    /** Porudžbenice izabrane smene po imenu (za period i po danu), obroci razvrstani po grupama jela. */
    slips() {
      return this.filterByShift
        .map((user) => {
          const name = [this.toLatin(user.name), this.toLatin(user.lastname)].filter(Boolean).join(" ").trim();
          const categories = this.dayCategoryList
            .map((category) => ({
              id: category.id,
              name: this.dayCategoryLabels[category.id],
              meals: user.orders
                .filter((order) => order.category_id === category.id && order.name)
                .map((order) => ({ quantity: order.quantity, name: this.toLatin(order.name) })),
            }))
            .filter((category) => category.meals.length);
          // stavke bez poznate grupe jela ne smeju nestati iz porudžbenice
          const loose = user.orders
            .filter((order) => order.name && !this.dayCategoryList.some((category) => category.id === order.category_id))
            .map((order) => ({ quantity: order.quantity, name: this.toLatin(order.name) }));
          if (loose.length) {
            categories.push({ id: "other", name: "", meals: loose });
          }
          return {
            key: user.key,
            userId: user.id,
            name,
            initials: [user.name, user.lastname]
              .filter(Boolean)
              .map((part) => String(part).charAt(0))
              .join(""),
            date: user.date,
            dateText: user.date && moment(user.date).isValid() ? moment(user.date).format("DD.MM.") : String(user.date || ""),
            categories,
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name) || String(a.date).localeCompare(String(b.date)));
    },
    workerTotal() {
      return new Set(this.slips.map((slip) => slip.userId)).size;
    },
    mealTotal() {
      return this.slips.reduce(
        (sum, slip) =>
          sum + slip.categories.reduce((inner, category) => inner + category.meals.reduce((s, meal) => s + (Number(meal.quantity) || 0), 0), 0),
        0
      );
    },
  },
};
